import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '../ogComponent/table';
import { IconCheck, IconX } from '@tabler/icons-react';
import Spinner from '../ogComponent/spinner';
import { Toast } from 'primereact/toast';

export default function ConvertRequests() {
    const [selectedRequest, setSelectedRequest] = useState("Pending Requests");
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const toast = useRef(null);

    const statusMap = {
        "Pending Requests": "Pending",
        "Approved Requests": "Approved",
        "Rejected Requests": "Rejected"
    };

    const fetchData = async () => {
        try {
            const token = localStorage.getItem("accessToken");
            const status = statusMap[selectedRequest] || "Pending";

            const url = `${process.env.REACT_APP_API}/api/leavemanagement/balance-leave-request/?status=${status}`;

            const response = await axios.get(url, {
                headers: { Authorization: `Bearer ${token}` }
            });

            const data = response.data.map((item, index) => ({
                id: item.id,
                Sino: index + 1,
                name: (
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <img
                            src={item.employee.profile_photo || "/assets/user.png"}
                            alt="Profile"
                            style={{
                                width: "30px",
                                height: "30px",
                                borderRadius: "50%",
                                marginRight: "10px",
                            }}
                        />
                        {item.employee.name || "N/A"}
                    </div>
                ),
                position: item.employee.job_position || "N/A",
                usercode: item.employee.employee_code,
                month: item.month,
                leave_days: item.requested_leaves,
                status: item.status,
                actions: getActions(item)
            }));

            setProducts(data);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [selectedRequest]);

    const handleSelect = (request) => {
        setSelectedRequest(request);
    };

    const handleAction = async (id, action) => {
        try {
            const token = localStorage.getItem("accessToken");
            const url = `${process.env.REACT_APP_API}/api/leavemanagement/balance-leave-request/approve_or_reject/${id}/`;

            await axios.post(url, { action }, {
                headers: { Authorization: `Bearer ${token}` }
            });

            fetchData();
            toast.current.show({
                severity: 'success',
                summary: 'Request Success',
                detail: 'Request Changed Succesfully',
                life: 3000,
            });
        } catch (error) {
            console.error("Error updating request:", error);
            toast.current.show({
                severity: 'error',
                summary: 'Request Failed',
                detail: error?.response?.data?.error,
                life: 3000,
            });
        }
    };

    const getActions = (item) => {
        if (item.status === "Pending") {
            return (
                <div className='d-flex flex-nowrap'>
                    <button className="btn btn-outline-success me-2 d-flex align-items-center" style={{ height: '25px' }} onClick={() => handleAction(item.id, "approve")}>
                        <IconCheck />
                    </button>
                    <button className="btn btn-outline-danger d-flex align-items-center" style={{ height: '25px' }} onClick={() => handleAction(item.id, "reject")}>
                        <IconX />
                    </button>
                </div>
            );
        } else if (item.status === "Approved") {
            return (
                <button className="btn btn-outline-danger d-flex align-items-center" style={{ height: '25px' }} onClick={() => handleAction(item.id, "reject")}>
                    <IconX />
                </button>
            );
        } else if (item.status === "Rejected") {
            return (
                <button className="btn btn-outline-success d-flex align-items-center" style={{ height: '25px' }} onClick={() => handleAction(item.id, "approve")}>
                    <IconCheck />
                </button>
            );
        }
    };

    const header = [
        { name: "Sino", label: "#", active: true },
        { name: "usercode", label: "Id", active: true },
        { name: "name", label: "Name", active: true },
        { name: "position", label: "Job Position", active: true },
        { name: "month", label: "Month", active: true },
        { name: "leave_days", label: "Leave Days", active: true },
        { name: "status", label: "Status", active: true },
        { name: "actions", label: "Actions", active: true }
    ];

    return (
        <div className='px-4 py-3 w-100'>
            <Toast ref={toast} position="bottom-right" />
            <h3 className='mb-3'>Leave Convert Requests</h3>
            <div className="dropdown d-flex align-items-center gap-2 gap-md-3 mb-3">
                <button
                    className="btn dropdown-toggle text-white border-0"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    style={{
                        fontSize: "clamp(12px, 1.4vw, 16px)",
                        backgroundColor: "#ba6f01",
                        maxHeight: "40px",
                        minWidth: "200px",
                    }}
                >
                    {selectedRequest}
                </button>
                <ul className="dropdown-menu">
                    {Object.keys(statusMap).map((status) => (
                        <li key={status} onClick={() => handleSelect(status)}>
                            <Link className="dropdown-item">{status}</Link>
                        </li>
                    ))}
                </ul>
            </div>
            {loading ? (
                <Spinner />
            ) : products.length > 0 ? (
                <Table product={products} header={header} onRowClick={() => { }} />
            ) : (
                <div className="d-flex justify-content-center align-items-end position-relative" style={{ height: "50vh" }}>
                    <div className="position-absolute top-0 start-0 w-100 h-100" style={{
                        backgroundImage: 'url(/assets/file.png)',
                        backgroundSize: 'contain',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        opacity: 0.3,
                    }}></div>
                    <p className="m-0 fw-light fs-5 position-relative">No Convert Requests !</p>
                </div>
            )}
        </div>
    );
}